import create from 'zustand';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('token'),
  user: null,
  isAuthenticated: !!localStorage.getItem('token'),
  
  setToken: (token) => {
    localStorage.setItem('token', token);
    set({ token, isAuthenticated: !!token });
  },
  
  clearToken: () => {
    localStorage.removeItem('token');
    set({ token: null, user: null, isAuthenticated: false });
  },
  
  setUser: (user) => set({ user }),
  updateUser: (fields) => set((state) => ({ user: { ...state.user, ...fields } })),
  
  logout: () => {
    localStorage.removeItem('token');
    set({ token: null, user: null, isAuthenticated: false });
  },
}));

export const useProductStore = create((set) => ({
  products: [],
  brandsModels: {},
  selectedProduct: null,
  filters: {
    search: '',
    brand: '',
    model: '',
  },
  
  setProducts: (products) => set({ products }),
  setBrandsModels: (brandsModels) => set({ brandsModels }),
  setSelectedProduct: (product) => set({ selectedProduct: product }),
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
  resetFilters: () => set({ filters: { search: '', brand: '', model: '' } }),
}));
